export const BILLS_TAB = 'BILLS';
export const LIMIT = 25;
